import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import ListItemText from '@material-ui/core/ListItemText';
import { Link, useLocation } from 'react-router-dom';
import * as Routes from '../../../constants/Routes';
import ProtectedSection from '../../ProtectedSection';
import Roles from '../../../constants/Roles';

export default function AuditLogMenuItem() {
  const location = useLocation();
  return (
    <ProtectedSection roles={[Roles.SuperUser]}>
      <ListItem button component={Link} to={Routes.AuditLog} selected={location.pathname.startsWith(Routes.AuditLog)}>
        <ListItemIcon>
          <AssignmentTurnedIn />
        </ListItemIcon>
        <ListItemText primary="Audit log" />
      </ListItem>
    </ProtectedSection>
  );
}
